module.exports = __webpack_public_path__ + "static/img/eyebrows_05.82f9663.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/eyebrows/thumbnail/eyebrows_05.png
// module id = JQr2
// module chunks = 0